import { createFileRoute } from "@tanstack/react-router";
import { buildingOptions } from "@/api";
import { SettingsSubPage } from "@/components/building_admin/building_admin_settings/SettingsSubPage";
import FoodBuildingSettings from "@/components/building_admin/building_admin_settings/food";
import { useRouterStore } from "@/store/zustandStore";
import { useWelcomeFoodAccess } from "@/hooks/useWelcomeFoodAccess";
import { useWelcomeSnackAccess } from "@/hooks/useWelcomeSnackAccess";

const PageComponent = () => {
  const { hasEitherFoodSystem } = useWelcomeFoodAccess(true);
  const { snackEnabledAndHasSupplier } = useWelcomeSnackAccess(true);

  const card = {
    value: "food",
    label: "Welcome Food",
    icon: "burger",
    descriptionKey: "PAGES.BUILDING_SETTINGS.MODULE_DESCRIPTIONS.FOOD",
    to: "/building/settings/food",
    enabled: hasEitherFoodSystem || snackEnabledAndHasSupplier,
  };
  return (
    <SettingsSubPage
      cardOptions={card}
      PageComponent={FoodBuildingSettings}
      label="Welcome Food"
      path="/building/settings/food"
    />
  );
};

export const Route = createFileRoute("/_portal/building/settings/food")({
  component: PageComponent,
  loader: async () => {
    const { queryClient } = useRouterStore.getState();
    if (!queryClient) return;
    queryClient.ensureQueryData(buildingOptions);
  },
});
